<template lang="pug">
.container
  #filter-box.categories
    //- small {{ loading }}
    .filter-list.categories-menu
      ul.flex-fill
        template(v-for="item in categoryMenu")
          template(v-if="item === 'favorite'")
            template(v-if="favGame && favGame.length > 0")
              li.filter(:data-filter='item == "all" ? item : "filter-" + item' :data-name='item' :class="{ 'active' : gameMenuSelected == item }" @click="setGameMenu(item)")
                .menu-icon
                  img(:src="'images/menu/' + item + '.png'")
                .menu-icon-active
                  img(:src="'images/menu/' + item + '-active.png'")
                .menu-text {{ $t("ui." + item) }}
          template(v-else)
            li.filter(:data-filter='item == "all" ? item : "filter-" + item' :data-name='item' :class="{ 'active' : gameMenuSelected == item }" @click="setGameMenu(item)")
              .menu-icon
                img(:src="'images/menu/' + item + '.png'")
              .menu-icon-active
                img(:src="'images/menu/' + item + '-active.png'")
              .menu-text {{ $t("ui." + item) }}
      //- .categories-search
      //-   .input-group
      //-     span.input-group-text
      //-       i.fa-solid.fa-magnifying-glass
      //-     input.form-control(type='text' :placeholder="$t('ui.search_game')")
    .filter-content.categories-content
      .grid.categories-thumnails
        template(v-if="gameMenuSelected === 'favorite'")
          .slot-wrapper 
            .slot-thumnails
              .row
                .col-3(v-for="game in favGame")
                  .icon-star.active(@click="deleteMemberFavGame(game)")
                    i.fa-solid.fa-star
                  a(href='javascript:void(0)' @click="launchDirectGame(game)")
                    .slot-picture
                      img.img-fluid(:src="game.img_url")
                    .slot-name {{ game.game_name }} 
        .row(v-else)
          .col-3.col-xl-2.grid-item.mix.all.filter-casino(v-if="getGameEnableStatus('PPC')")
            a(href='javascript:void(0);' @click="!loading && launchCasino('PPC')")
              .disable-text(v-if="loading")
                .i.fas.fa-sync.fa-spin
              img.img-fluid(src='images/product/ppc.png')
          .col-3.col-xl-2.grid-item.mix.all.filter-casino(v-if="getGameEnableStatus('EVO')")
            a(href='javascript:void(0);' @click="!loading && launchCasino('EVO')")
              .disable-text(v-if="loading")
                .i.fas.fa-sync.fa-spin
              img.img-fluid(src='images/product/ev.png')
          .col-3.col-xl-2.grid-item.mix.all.filter-slot.filter-hot(v-if="getGameEnableStatus('LIVE22')")
            a(href='javascript:void(0);' @click="launchSlot('LIVE22')")
              img.img-fluid(src='images/product/l2.png')
          .col-3.col-xl-2.grid-item.mix.all.filter-slot(v-if="getGameEnableStatus('UU')")
            a(href='javascript:void(0);' @click="launchSlot('UU')")
              img.img-fluid(src='images/product/uu.png')
          .col-3.col-xl-2.grid-item.mix.all.filter-slot(v-if="getGameEnableStatus('PPS')")
            a(href='javascript:void(0);' @click="launchSlot('PPS')")
              img.img-fluid(src='images/product/pps.png')
          .col-3.col-xl-2.grid-item.mix.all.filter-sports.filter-hot(v-if="getGameEnableStatus('WBET')")
            a(href='javascript:void(0);' @click="!loading && launchSport('WBET')")
              .disable-text(v-if="loading")
                .i.fas.fa-sync.fa-spin
              img.img-fluid(src='images/product/wb.png')

          .col-3.col-xl-2.grid-item.mix.all.filter-casino.disable(v-if="getGameEnableStatus('YB')")
            a(href='javascript:void(0);')
              .disable-text
                span {{ $t("ui.coming_soon") }}
              img.img-fluid(src='images/product/yb.png')          
          .col-3.col-xl-2.grid-item.mix.all.filter-casino.disable
            a(href='javascript:void(0);')
              .disable-text
                span {{ $t("ui.coming_soon") }}
              img.img-fluid(src='images/product/ai.png')          
          .col-3.col-xl-2.grid-item.mix.all.filter-casino.disable
            a(href='javascript:void(0);')
              .disable-text
                span {{ $t("ui.coming_soon") }}
              img.img-fluid(src='images/product/vv.png')
          .col-3.col-xl-2.grid-item.mix.all.filter-casino.disable
            a(href='javascript:void(0);')
              .disable-text
                span {{ $t("ui.coming_soon") }}
              img.img-fluid(src='images/product/bl.png')
          .col-3.col-xl-2.grid-item.mix.all.filter-casino.disable
            a(href='javascript:void(0);')
              .disable-text
                span {{ $t("ui.coming_soon") }}
              img.img-fluid(src='images/product/ls.png')
          .col-3.col-xl-2.grid-item.mix.all.filter-slot.disable
            a(href='javascript:void(0);')
              .disable-text
                span {{ $t("ui.coming_soon") }}
              img.img-fluid(src='images/product/ep.png')          
          .col-3.col-xl-2.grid-item.mix.all.filter-slot.disable
            a(href='javascript:void(0);')
              .disable-text
                span {{ $t("ui.coming_soon") }}
              img.img-fluid(src='images/product/gh.png')
          .col-3.col-xl-2.grid-item.mix.all.filter-slot.disable
            a(href='javascript:void(0);')
              .disable-text
                span {{ $t("ui.coming_soon") }}
              img.img-fluid(src='images/product/sg.png')
          .col-3.col-xl-2.grid-item.mix.all.filter-slot.disable
            a(href='javascript:void(0);')
              .disable-text
                span {{ $t("ui.coming_soon") }}
              img.img-fluid(src='images/product/ps.png')          
          .col-3.col-xl-2.grid-item.mix.all.filter-slot.disable
            a(href='javascript:void(0);')
              .disable-text
                span {{ $t("ui.coming_soon") }}
              img.img-fluid(src='images/product/wg.png')
          .col-3.col-xl-2.grid-item.mix.all.filter-slot.disable
            a(href='javascript:void(0);')
              .disable-text
                span {{ $t("ui.coming_soon") }}
              img.img-fluid(src='images/product/cc.png')
          
          //- .col-3.col-xl-2.grid-item.mix.all
          //-   a(href='javascript:void(0);')
          //-     img.img-fluid(src='images/product/horse.png')
          //- .col-3.col-xl-2.grid-item.mix.all.filter-poker
          //-   a(href='javascript:void(0);')
          //-     img.img-fluid(src='images/product/poker.png')
          //- .col-3.col-xl-2.grid-item.mix.all.filter-lottery
          //-   a(href='javascript:void(0);')
          //-     img.img-fluid(src='images/product/lottery.png')

</template>

<script>
export default {
  data() {
    return {
      loading: false,
      feedback: {
        success: true,
        status: ""
      },
      categoryMenu: ['all','hot','favorite','sports','slot','casino']
    }
  },
  computed: {
    isLoggedIn(){
      return this.$store.getters.isLoggedIn
    },
    accountID() {
      return this.$store.getters.accountID
    },
    sessionToken() {
      return this.$store.getters.sessionToken
    },
    provider() {
      return this.$store.getters.provider
    },
    gameMenuSelected() {
      return this.$store.getters.gameMenuSelected
    },
    providerList() {
      return this.isLoggedIn ? this.$store.state.user.account.provider_list.filter(item => item.enable_provider === true) : ""
    },
    favGame() {
      return this.$store.getters.favGame
    }    
  },
  mounted() {
    $('.categories .filter-list ul li').click(function(){
      var filter_class = $(this).data('filter');
      var filter_name = $(this).data('name');
      
      // $('.categories-title').html(filter_name);

      if(filter_name == 'favorite') {
        $('.categories .filter-content .grid-item').addClass('d-none');
        $('.categories .filter-content .grid-item .icon-star.active').parent().removeClass('d-none');
      } else {
        $('.categories .filter-content .grid-item').addClass('d-none');
        $('.categories .filter-content .grid-item.'+filter_class).removeClass('d-none');
      }
    });

    this.getMobile()
  },
  destroyed() { },
  methods: {
    getMobile() {
      if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
        this.mobileDevice = true
      }else{
        this.mobileDevice = false
      }
    },
    deleteMemberFavGame(game) {
      if(this.isLoggedIn) {
        let login_id = this.accountID
        let auth_token = this.sessionToken
        let provider_code = game.provider_code
        let game_code = game.game_code
        this.loading = true
        this.$store
          .dispatch("user/deleteMemberFavGame", { login_id, auth_token, provider_code, game_code })
          .then(response => {
            this.loading = false
            this.feedback.success = response.success
            this.feedback.status = response.status
            if (this.feedback.success == true) {   
              this.getMemberFavGame()
            }
          })
          .catch(response => {
            this.loading = false
            this.feedback.success = false              
            this.feedback.status = this.$t("error." + response.status)
            this.$helpers.showDialog(this.$t("ui.cancel").toUpperCase(), this.$t("message.list." + response.status), "error")
          });
      }
    },
    getMemberFavGame() {
      if (this.isLoggedIn) {
        this.loading = true
        let login_id = this.accountID
        let auth_token = this.sessionToken
        this.$store.dispatch("user/getMemberFavGame", { login_id, auth_token }).then(
          res => {
            this.loading = false
            if (res.success) {
              // console.log(res.data.length)
            } else {
              this.$helpers.showDialog(this.$t("ui.cancel"), this.$t("message.list." + res.status), "error")
            }
          },
          err => {
            this.loading = false
            this.$helpers.showDialog(this.$t("ui.cancel"), this.$t("message.list." + err.status), "error")
          }
        );
      }
    },
    setGameMenu(game) {
      this.$store.dispatch("user/setGameMenuSelected", game)
    },
    getGameEnableStatus(game){
			if (this.isLoggedIn) {
        return this.providerList.filter(item => item.provider_code === game).length > 0
      }
      return true
		},
    launchSlot(game){
			if (this.isLoggedIn) {
        this.$store.dispatch("user/setProvider", game);
        this.$router.push("/" + game.toLowerCase())
      } else {
        $('#modal-login').modal('show')
      }
		},
    launchCasino(game) {
      let provider = game.toLowerCase()
      let gameUrl = ""
      switch (provider) {
        case "ppc":
          gameUrl = "provider/launchPPC"
          break;
        case "yb":
          gameUrl = "provider/launchYB"
          break;
        case "evo":
          gameUrl = "provider/launchEVO"
          break;
        default:
          break;
      }

      if (this.isLoggedIn) {
        let player_id = this.accountID
        let auth_token = this.sessionToken
        let lang_code = "en"
        let mobile = this.mobileDevice
        this.loading = true
        this.$store
          .dispatch(gameUrl, { player_id, auth_token, lang_code, mobile })
          .then(response => {
            this.loading = false
            if (response.success == true) {
							setTimeout(() => {
								window.open(response.data, "_blank")
							}) 
            } else {       
              this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info")
            }
          })
          .catch(response => {
            this.loading = false
            if(response.data.length > 0) {
              this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info")
            } else {
              this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list.technicalError"), "info")
            }
          });
      } else {
				$('#modal-login').modal('show')
			}
    },
    launchSport(game) {
      let provider = game.toLowerCase()
      let gameUrl = ""
      switch (provider) {
        case "wbet":
          gameUrl = "provider/launchWB"
          break;
        default:
          break;
      }

      if (this.isLoggedIn) {
        let player_id = this.accountID
        let auth_token = this.sessionToken
        let lang_code = "en"
        let type = this.mobileDevice ? "2" : "1"
        this.loading = true
        this.$store
          .dispatch(gameUrl, { player_id, auth_token, lang_code, type })
          .then(response => {
            this.loading = false
            if (response.success == true) {
							setTimeout(() => {
								window.open(response.data, "_blank")
							}) 
            } else {     5        
              this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info")
            }
          })
          .catch(response => {
            this.loading = false
            if(response.data.length > 0) {
              this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info")
            } else {
              this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list.technicalError"), "info")
            }
          });
      } else {
				$('#modal-login').modal('show')
			}
    },
    launchDirectGame(game) {
      let provider = game.provider_code.toLowerCase()
      let gameUrl = ""

      switch (provider) {
        case "live22":
          gameUrl = "provider/launchLive22"
          break;
        case "uu":
          gameUrl = "provider/launchUuslot"
          break;
        case "pps":
          gameUrl = "provider/launchPPS"
          break;
        default:
          break;
      }

      if (this.isLoggedIn) {
        let player_id = this.accountID
        let auth_token = this.sessionToken
        let game_code = game.game_code
        let lang_code = "en"
        let mobile = this.mobileDevice
        this.loading = true
        this.$store
          .dispatch(gameUrl, { player_id, auth_token, lang_code, game_code, mobile })
          .then(response => {
            this.loading = false
            if (response.success == true) {
							setTimeout(() => {
								window.open(response.data, "_blank")
							}) 
            } else {             
              this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info")
            }
          })
          .catch(response => {
            this.loading = false
            if(response.data.length > 0) {
              this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info")
            } else {
              this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list.technicalError"), "info")
            }
          });
      } else {
				$('#modal-login').modal('show')
			}
    }
  }
}
</script>